"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleText = exports.SubText = exports.SingleLineCheckbox = exports.ShowForSmallOnly = exports.ShowForMediumUp = exports.RightAlignCol = exports.ResponsiveBody = exports.MaxWidthTextField = exports.MaxWidthFormattedTextField = exports.MaxWidthContent = exports.InvisibleIFrame = exports.InputCol = exports.HiddenSubmit = exports.FormattedForm = exports.CompanyLogoModified = exports.ColorChangeHeader = exports.ColorChangeFooter = exports.ClickableAnchor = exports.CheckboxWithMargin = void 0;
var _FormattedTextField = _interopRequireDefault(require("@cx/couturier/FormattedTextField"));
var _TextField = _interopRequireDefault(require("@cx/couturier/TextField"));
var _Checkbox = _interopRequireDefault(require("@cx/couturier/Checkbox"));
var _ImmersiveFlow = require("@cx/couturier/labs/ImmersiveFlow");
var _CompanyLogo = _interopRequireDefault(require("@cx/couturier/CompanyLogo"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Grid = require("@cx/couturier/Grid");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-confusing-arrow */

var RightAlignCol = exports.RightAlignCol = (0, _styledComponents.default)(_Grid.Col).withConfig({
  displayName: "util-components__RightAlignCol",
  componentId: "sc-1cuwwjq-0"
})(["text-align:right;"]);
var CompanyLogoModified = exports.CompanyLogoModified = (0, _styledComponents.default)(_CompanyLogo.default).withConfig({
  displayName: "util-components__CompanyLogoModified",
  componentId: "sc-1cuwwjq-1"
})(["&&{height:4.75rem;line-height:initial;width:15rem;", "}"], function (_ref) {
  var media = _ref.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["height:4rem;"]));
});
var ClickableAnchor = exports.ClickableAnchor = _styledComponents.default.a.withConfig({
  displayName: "util-components__ClickableAnchor",
  componentId: "sc-1cuwwjq-2"
})(["cursor:pointer;"]);
var MaxWidthContent = exports.MaxWidthContent = _styledComponents.default.div.withConfig({
  displayName: "util-components__MaxWidthContent",
  componentId: "sc-1cuwwjq-3"
})(["max-width:20.25rem;"]);
var HiddenSubmit = exports.HiddenSubmit = _styledComponents.default.button.withConfig({
  displayName: "util-components__HiddenSubmit",
  componentId: "sc-1cuwwjq-4"
})(["&&{display:none;}"]);
var ColorChangeHeader = exports.ColorChangeHeader = (0, _styledComponents.default)(_ImmersiveFlow.Header).withConfig({
  displayName: "util-components__ColorChangeHeader",
  componentId: "sc-1cuwwjq-5"
})(["&&{background-color:", ";color:", ";transition:background-color 0.5s cubic-bezier(0.445,0.05,0.55,0.95);path{fill:", ";}@media print{position:relative;}}"], function (_ref2) {
  var isAltColor = _ref2.isAltColor,
    theme = _ref2.theme;
  return isAltColor ? theme.colors.primary.nmBlue : 'inherit';
}, function (_ref3) {
  var isAltColor = _ref3.isAltColor,
    theme = _ref3.theme;
  return isAltColor ? theme.colors.neutral.white : 'inherit';
}, function (_ref4) {
  var isAltColor = _ref4.isAltColor,
    theme = _ref4.theme;
  return isAltColor ? theme.colors.neutral.white : 'inherit';
});
var ColorChangeFooter = exports.ColorChangeFooter = (0, _styledComponents.default)(_ImmersiveFlow.Footer).withConfig({
  displayName: "util-components__ColorChangeFooter",
  componentId: "sc-1cuwwjq-6"
})(["&&{background-color:", ";color:", ";transition:background-color 0.5s cubic-bezier(0.445,0.05,0.55,0.95);}"], function (_ref5) {
  var isAltColor = _ref5.isAltColor,
    theme = _ref5.theme;
  return isAltColor ? theme.colors.primary.nmBlue : 'inherit';
}, function (_ref6) {
  var isAltColor = _ref6.isAltColor,
    theme = _ref6.theme;
  return isAltColor ? theme.colors.neutral.white : 'inherit';
});
var ResponsiveBody = exports.ResponsiveBody = (0, _styledComponents.default)(_ImmersiveFlow.Body).withConfig({
  displayName: "util-components__ResponsiveBody",
  componentId: "sc-1cuwwjq-7"
})(["background-color:", ";color:", ";padding-top:", ";", " & > div{width:100%;}"], function (_ref7) {
  var isAltColor = _ref7.isAltColor,
    theme = _ref7.theme;
  return isAltColor ? theme.colors.primary.nmBlue : 'inherit';
}, function (_ref8) {
  var isAltColor = _ref8.isAltColor,
    theme = _ref8.theme;
  return isAltColor ? theme.colors.neutral.white : 'inherit';
}, function (_ref9) {
  var hasNotification = _ref9.hasNotification;
  return hasNotification ? '0' : '11rem';
}, function (_ref10) {
  var media = _ref10.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["padding-top:", ";"], function (_ref11) {
    var hasNotification = _ref11.hasNotification;
    return hasNotification ? '2rem' : '5.5rem';
  }));
});
var TitleText = exports.TitleText = _styledComponents.default.h1.attrs(function () {
  return {
    className: 'ui-h3'
  };
}).withConfig({
  displayName: "util-components__TitleText",
  componentId: "sc-1cuwwjq-8"
})(["&&&{color:", ";letter-spacing:", ";", " @media all and (max-width:23.5rem){max-width:16.375rem;}}"], function (_ref12) {
  var theme = _ref12.theme,
    isAltColor = _ref12.isAltColor;
  return isAltColor ? theme.colors.neutral.white : theme.colors.primary.nmBlue;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.luna ? '0' : '1px';
}, function (_ref14) {
  var hasSubtitle = _ref14.hasSubtitle,
    media = _ref14.theme.media;
  return hasSubtitle ? (0, _styledComponents.css)(["margin-bottom:8px;"]) : (0, _styledComponents.css)(["margin-bottom:40px;", " ", ""], media.mediumLarge((0, _styledComponents.css)(["margin-bottom:32px;"])), media.smallMedium((0, _styledComponents.css)(["margin-bottom:24px;"])));
});
var SubText = exports.SubText = _styledComponents.default.p.withConfig({
  displayName: "util-components__SubText",
  componentId: "sc-1cuwwjq-9"
})(["&&{color:", ";font-weight:400;letter-spacing:0.5px;margin-bottom:40px;", " ", " @media all and (max-width:23.5rem){max-width:16.375rem;}}"], function (_ref15) {
  var theme = _ref15.theme,
    isAltColor = _ref15.isAltColor;
  return isAltColor ? theme.colors.neutral.white : theme.colors.neutral.silverDollar;
}, function (_ref16) {
  var media = _ref16.theme.media;
  return media.mediumLarge((0, _styledComponents.css)(["margin-bottom:32px;"]));
}, function (_ref17) {
  var media = _ref17.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["margin-bottom:24px;"]));
});
var FormattedForm = exports.FormattedForm = _styledComponents.default.form.withConfig({
  displayName: "util-components__FormattedForm",
  componentId: "sc-1cuwwjq-10"
})([""]);
var ShowForMediumUp = exports.ShowForMediumUp = (0, _styledComponents.default)(_Grid.Col).withConfig({
  displayName: "util-components__ShowForMediumUp",
  componentId: "sc-1cuwwjq-11"
})(["display:none;", ";"], function (_ref18) {
  var media = _ref18.theme.media;
  return media.medium((0, _styledComponents.css)(["display:block;"]));
});
var ShowForSmallOnly = exports.ShowForSmallOnly = (0, _styledComponents.default)(_Grid.Col).withConfig({
  displayName: "util-components__ShowForSmallOnly",
  componentId: "sc-1cuwwjq-12"
})(["display:block;", ";"], function (_ref19) {
  var media = _ref19.theme.media;
  return media.medium((0, _styledComponents.css)(["display:none;"]));
});
var InvisibleIFrame = exports.InvisibleIFrame = _styledComponents.default.iframe.withConfig({
  displayName: "util-components__InvisibleIFrame",
  componentId: "sc-1cuwwjq-13"
})(["visibility:hidden;opacity:0;"]);
var MaxWidthTextField = exports.MaxWidthTextField = (0, _styledComponents.default)(_TextField.default).withConfig({
  displayName: "util-components__MaxWidthTextField",
  componentId: "sc-1cuwwjq-14"
})(["&&{margin-bottom:", ";max-width:20.25rem;}"], function (_ref20) {
  var noMargin = _ref20.noMargin;
  return noMargin ? 0 : '2.625rem';
});
var MaxWidthFormattedTextField = exports.MaxWidthFormattedTextField = (0, _styledComponents.default)(_FormattedTextField.default).withConfig({
  displayName: "util-components__MaxWidthFormattedTextField",
  componentId: "sc-1cuwwjq-15"
})(["&&{margin-bottom:", ";max-width:20.25rem;}"], function (_ref21) {
  var noMargin = _ref21.noMargin;
  return noMargin ? 0 : '2.625rem';
});
var SingleLineCheckbox = exports.SingleLineCheckbox = (0, _styledComponents.default)(_Checkbox.default).withConfig({
  displayName: "util-components__SingleLineCheckbox",
  componentId: "sc-1cuwwjq-16"
})(["&&{display:block;}"]);
var CheckboxWithMargin = exports.CheckboxWithMargin = (0, _styledComponents.default)(_Checkbox.default).withConfig({
  displayName: "util-components__CheckboxWithMargin",
  componentId: "sc-1cuwwjq-17"
})(["&&{font-size:15px;margin-top:1.5rem;}"]);
var InputCol = exports.InputCol = (0, _styledComponents.default)(_Grid.Col).withConfig({
  displayName: "util-components__InputCol",
  componentId: "sc-1cuwwjq-18"
})(["&&{padding-left:0;max-width:318px;}"]);